import {
  LOAD_PRODUCT,
  SHOW_PRODUCT,
  CREATE_PRODUCT,
  UPDATE_PRODUCT,
  EXPORT_PRODUCT,
  IMPORT_PRODUCT,
  DELETE_PRODUCT,
} from "./actions";

const initialState = {
  lists: [],
  total_rows: 0,
  loading: false,
  shouldRedirect: false,
  data: {
    id: "",
    code: "",
    company_id: "",
    product_type_id: "",
    strength_id: "",
    slump_id: "",
    vehicle_type_id: "",
    delivery_distance_id: "",
    structures: [],
  },
  success_msg: "",
  err_msg: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOAD_PRODUCT.REQUEST:
    case SHOW_PRODUCT.REQUEST:
    case CREATE_PRODUCT.REQUEST:
    case UPDATE_PRODUCT.REQUEST:
    case EXPORT_PRODUCT.REQUEST:
    case IMPORT_PRODUCT.REQUEST:
    case DELETE_PRODUCT.REQUEST:
      return {
        ...state,
        loading: true,
        success_msg: "",
        err_msg: "",
        shouldRedirect: false,
      };
    case LOAD_PRODUCT.SUCCESS:
      return {
        ...state,
        lists: action.payload.data.data,
        total_rows: action.payload.data.total_rows,
        loading: false,
      };
    case SHOW_PRODUCT.SUCCESS:
      return { ...state, data: action.payload.data.data, loading: false };
    case CREATE_PRODUCT.SUCCESS:
    case UPDATE_PRODUCT.SUCCESS:
      return {
        ...state,
        success_msg:
          (action.payload &&
            action.payload.data &&
            action.payload.data.message) ||
          "success",
        loading: false,
        shouldRedirect: true,
      };
    case EXPORT_PRODUCT.SUCCESS:
      return {
        ...state,
        success_msg: "export_success",
        loading: false,
        err_msg: "",
      };

    case IMPORT_PRODUCT.SUCCESS:
      return {
        ...state,
        success_msg: "import_success",
        loading: false,
        shouldReload: true,
      };

    case DELETE_PRODUCT.SUCCESS:
      return {
        ...state,
        success_msg: "delete_success",
        lists: state.lists.filter((x) => x.id !== action.payload.id),
        loading: false,
        shouldReload: true,
      };
    case LOAD_PRODUCT.FAILURE:
    case SHOW_PRODUCT.FAILURE:
    case CREATE_PRODUCT.FAILURE:
    case UPDATE_PRODUCT.FAILURE:
    case EXPORT_PRODUCT.FAILURE:
    case IMPORT_PRODUCT.FAILURE:
    case DELETE_PRODUCT.FAILURE:
      return { ...state, err_msg: action.payload.err, loading: false };
    default:
      return state;
  }
};
